// extracted by mini-css-extract-plugin
export default {"defaultStyle":"ActionButton_defaultStyle__Vbj5g","spinner":"ActionButton_spinner__wVeME"};